<div class="spacing--margin-horizontal spacing--margin-top">
  <ul class="info-header">
    <li>
      <label class="text-bold">{{ 'feed-advice.print.farmcompany' | translate }}:</label>
      <label class="wide-label" *ngIf="customer$ | async as customer">
        {{ customer?.name }}, {{ customer?.street }} {{ customer?.houseNumber }}
        {{ customer?.houseNumberAddition }}, {{ customer?.city }}
      </label>
    </li>
    <li>
      <label class="text-bold">{{ 'feed-advice.print.location' | translate }}:</label>
      <label class="wide-label" *ngIf="location$ | async as location">
        {{ location?.name }}, {{ location?.street }} {{ location?.houseNumber }}
        {{ location?.houseNumberAddition }}, {{ location?.city }}
      </label>
    </li>
    <li>
      <label class="text-bold">{{ 'feed-advice.print.customernr' | translate }}:</label>
      <label>{{ (customer$ | async)?.externalId }}</label>
    </li>
    <li>
      <label class="text-bold">{{ 'feed-advice.create.created' | translate }}:</label>
      <label class="wide-label"> {{ feedAdvice?.created | agrDate }}</label>
    </li>
    <li>
      <label class="text-bold">{{ 'feed-advice.create.updated' | translate }}:</label>
      <label class="wide-label"> {{ feedAdvice?.updated | agrDate }}</label>
    </li>
    <li *ngIf="(customer$ | async)?.country === 'NL'">
      <label class="text-bold">{{ 'feed-advice.print.customerservice' | translate }}:</label>
      <label class="wide-label">{{ getCustomerServiceInfo((customer$ | async)?.country) }}</label>
    </li>
  </ul>
</div>
<h5 class="text--h5 spacing--padding-top">{{ 'feed-advice.create.products' | translate }}</h5>
<div class="wrapper--spacing-horizontal spacing--margin-horizontal">
  <table>
    <thead>
      <tr>
        <th></th>
        <th>{{ 'feed-advice.print.table-header.age' | translate }}</th>
        <th *ngIf="hasProductComments()"></th>
      </tr>
      <tr>
        <th>{{ 'feed-advice.print.table-header.productName' | translate }}</th>
        <th>{{ 'feed-advice.print.table-header.units_weeks' | translate }}</th>
        <th *ngIf="hasProductComments()">
          {{ 'feed-advice.print.table-header.comment' | translate }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of feedAdvice.productRows">
        <td>{{ row.product?.code }} - {{ row.product?.name }}</td>
        <td class="text--center">
          {{ row.ageFrom }} -
          {{ row.ageTo ?? ('flock-overview.panel.departure-title' | translate) }}
        </td>
        <td *ngIf="hasProductComments()">{{ row.comment }}</td>
      </tr>
    </tbody>
  </table>
</div>

<h5 class="text--h5 spacing--padding-top">{{ 'feed-advice.create.additives' | translate }}</h5>
<div class="wrapper--spacing-horizontal spacing--margin-horizontal">
  <table>
    <thead>
      <tr>
        <th></th>
        <th>{{ 'feed-advice.print.table-header.dosage' | translate }}</th>
        <th>{{ 'feed-advice.print.table-header.applicationMoment' | translate }}</th>
        <th *ngIf="hasAdditiveComments()"></th>
      </tr>
      <tr>
        <th>{{ 'feed-advice.print.table-header.productName' | translate }}</th>
        <th>{{ 'feed-advice.print.table-header.units_kgton' | translate }}</th>
        <th></th>
        <th *ngIf="hasAdditiveComments()">
          {{ 'feed-advice.print.table-header.comment' | translate }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of feedAdvice.additiveRows">
        <td>{{ row.product?.code }} - {{ row.product?.name }}</td>
        <td class="text--center">{{ row.dosage }}</td>
        <td class="text--center">{{ row.applicationMoment }}</td>
        <td *ngIf="hasAdditiveComments()">{{ row.comment }}</td>
      </tr>
    </tbody>
  </table>
</div>

<div class="spacing--margin-horizontal extra-margin-top" *ngIf="feedAdvice?.description">
  <ul class="info-header">
    <li>
      <label class="text-bold">{{ 'feed-advice.create.description' | translate }}:</label>
      <label class="wide-label">{{ feedAdvice?.description }}</label>
    </li>
  </ul>
</div>
